<template>
  <main>
    <wl-banner bgUrl='/static/img/product/zhsys/banner.png' :bannerData='bannerData' paddingTop='214px'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1">
      <article class="container flex">
        <wl-title :title='page1Data.title' :desc='page1Data.desc'></wl-title>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/product/zhsys/bg2.png'">
      <article class="container">
        <section class="center">
          <h2>数据中台</h2>
          <p>打通以往的数据孤岛沉淀数据资产，实现价值共通</p>
        </section>
        <section class="box1">
          <h3>{{data[0].title}}</h3>
          <p>{{data[0].desc}}</p>
        </section>
        <section class="box2">
          <h3>{{data[1].title}}</h3>
          <p>{{data[1].desc}}</p>
          <p class="pl-10">智慧的实验室</p>
        </section>
        <section class="box3">
          <h3>{{data[2].title}}</h3>
          <p>{{data[2].desc}}</p>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>


<script>
export default {
  name: 'zhsysManagePlatform',
  data() {
    return {
      bannerData: {
        title: '智慧实验室管理平台',
        desc: '集物联网智能硬件、业务系统、数据中台、\n智能预警应急预案于一体三维可视化平台'
      },
      page1Data: {
        title: '智慧实验室管理平台',
        desc: '智慧实验室管理平台将安全教育考试准入、危化品管理、仪器设备、气体监测、 环境监控等各类运行指标数据配合物联网和大数据分析，对安全隐患、异常情况预警，做及时预案处理，有利于指导实验室建设和管理，合理配置公共资源，做出科学决策，提高治理效能。'
      },
      data: [
        {title: '多业务系统联动', desc: '· 安全考试准入系统\n· 危化品管理系统\n· 仪器预约共享系统\n· 智能环境监测系统\n· 安全检查管理系统等'},
        {title: '智能硬件，物联应用', desc: '· 物联网智能硬件\n· 灵活搭载业务系统\n· 共同打造安全、便捷、'},
        {title: '3D全景可视化展示', desc: '· 迅速定位楼宇、实验室房间等目标信息  \n· 360°全空间记录、展示、监控实验室\n· 各业务数据一览无余，可视化展示'},
      ]
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
main {
  background: #fbfbff;
}
h3 {
  font-size: 24px;
  font-weight: 500;
  color: #262626;
  line-height: 24px;
  padding-bottom: 32px;
}
p {
  font-size: 20px;
  color: #8e8e8e;
  line-height: 32px;
  white-space: pre-line;
  text-align: left;
}
.pl-10 {
  padding-left: 10px;
}
.page1 {
  height: 1530px;
  padding-top: 136px;
  background: url("/static/img/product/zhsys/bg1.png") center/cover;
  ::v-deep strong {
    color: #8e8e8e;
    padding-top: 54px;
    line-height: 34px;
    text-align: left;
  }
}
.page2 {
  height: 1029px;
  .container {
    position: relative;
    height: 100%;
    .center{
      width: 220px;
      position: absolute;
      left: 520px;
      top: 245px;
      h2{
        font-size: 36px;
        line-height: 36px;
        font-weight: 500;
        color: #308DFF;
        padding-bottom: 24px;
      }
      p{
        line-height: 30px;
      }
    }
    .box1 {
      width: 196px;
      position: absolute;
      left: 35px;
      top: 227px;
    }
    .box2 {
      width: 216px;
      position: absolute;
      left: 1020px;
      top: 227px;
    }
    .box3{
      width: 365px;
      position: absolute;
      left: 447px;
      top: 714px;
      h3{
        text-align: left;
        padding-left: 131px;
      }
    }
  }
}
</style>
